import { useCurrentGroupStore } from '../stores/useCurrentGroupStore';
import { useCurrentGroupMembersStore } from '../stores/useCurrentGroupMembersStore';

export const useEnsureGroupData = (groupId) => {
    const currentGroupId = useCurrentGroupStore((state) => state.groupId);
    const fetchGroup = useCurrentGroupStore((state) => state.fetchGroup);
    const fetchMembers = useCurrentGroupMembersStore((state) => state.fetchGroupMembers);
    const currentGroupMemberGroupId = useCurrentGroupMembersStore((state) => state.groupId);

    if (groupId && currentGroupId !== groupId) {
        fetchGroup(groupId);
    }

    if (currentGroupMemberGroupId !== groupId) {
        fetchMembers(groupId);
    }
};